module.exports = {
	"sidebar.section.main_menu": "Main Menu",
	"sidebar.dashboard": "Dashboard",
	"sidebar.report": "Report",
}
